// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see BusinessAccountKYBUnsupportedEvent
 */
export var BusinessAccountKYBUnsupported = function (_a) {
    var customerToken = _a.customerToken, flowToken = _a.flowToken, kybUseCase = _a.kybUseCase, businessType = _a.businessType, unsupportedReason = _a.unsupportedReason;
    return ({
        name: "BusinessAccount KYB Unsupported",
        parameters: {
            cdf_entity: "BusinessAccount",
            cdf_action: "KYB",
            customer_token: customerToken !== undefined && customerToken !== null ? customerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            kyb_use_case: kybUseCase !== undefined && kybUseCase !== null ? kybUseCase.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            business_type: businessType !== undefined && businessType !== null ? businessType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            unsupported_reason: unsupportedReason !== undefined && unsupportedReason !== null ? unsupportedReason.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
